import React, { Component } from 'react';
import DispatchProps from "../../../utils/DispatchProps";
import Playlist from "../../../models/Playlist";
import Table, {TableColumn} from "../../Table";
import * as _ from "lodash";
import TableCell from "../../TableCell";

interface PlaylistDefinitionTableProps {
    playlists?: Playlist[];
}

interface PlaylistDefinitionTableState {
}

export class PlaylistDefinitionTable extends Component<PlaylistDefinitionTableProps, PlaylistDefinitionTableState> {
    static displayName = PlaylistDefinitionTable.name;

    private static readonly columns = [
        {title: "Name",propertyPath: "name", flex: 1},
        {title: "Workload Running Order",propertyPath: "runningOrder", flex: 5},
    ];

    constructor(props: PlaylistDefinitionTableProps) {
        super(props);

        this.state = {
        }
    }

    async componentDidMount() {

    }

    async componentDidUpdate(prevProps: Readonly<PlaylistDefinitionTableProps & DispatchProps>, prevState: any): Promise<void> {

    }
    
    private cellForColumn = (item: Playlist, column: TableColumn, index: number): JSX.Element | undefined => {
        
        if(column.propertyPath === "runningOrder")
        {
            return (<TableCell key={column.propertyPath} flex={column.flex}>{_.join(item.runningOrder,", ")}</TableCell>);
        }
        
        return;
    }

    render() {
        return (
            <Table title={"Playlist Definitions"} cellForColumn={this.cellForColumn} columns={PlaylistDefinitionTable.columns} items={this.props.playlists ? this.props.playlists : []}>

            </Table>
        );
    }
}